import {AfterContentInit, Component, ContentChild, ElementRef, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';
import {NgClass} from '@angular/common';

export type ToggleColor = 'dark' | 'red-green' | 'flat-blue_gray-indigo' | '';

/**
 * Supply an <input type="checkbox" #checkboxEl> element to this class
 * as projected content. The #checkboxEl is mandatory.
 */
@Component({
  selector: 'motn-toggle-input-wrapper',
  templateUrl: './toggle-input-wrapper.component.html',
  styleUrls: ['./toggle-input-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    NgClass,
  ],
})
export class ToggleInputWrapperComponent implements AfterContentInit {

  @Input() color: ToggleColor;
  @Output() toggled$: EventEmitter<boolean> = new EventEmitter<boolean>();

  @ContentChild('checkboxEl', {static: false}) checkboxEl!: ElementRef<HTMLInputElement>;


  constructor() {
  }


  ngAfterContentInit(): void {
    if (!this.checkboxEl?.nativeElement || typeof this.checkboxEl.nativeElement.disabled !== 'boolean') {
      console.error(`ToggleInputWrapperComponent instantiated without projected content. See doc block for more info.`);
    }
  }


  get classes(): string[] {
    const classes: string[] = ['toggle', 'small'];

    if (this.color) {
      classes.push(this.color);
    }

    return classes;
  }

}
